import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

export default function AdminWorkOrders() {
  const [wos, setWos] = useState([]);
  const [q, setQ] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    api.get("/work-orders").then((r) => setWos(r.data));
  }, []);

  const filtered = wos.filter((w) => {
    if (statusFilter !== "all" && w.status !== statusFilter) return false;
    if (!q) return true;
    const s = q.toLowerCase();
    return (
      w.property_address?.toLowerCase().includes(s) ||
      w.service_type?.toLowerCase().includes(s) ||
      w.client_name?.toLowerCase().includes(s) ||
      w.client_email?.toLowerCase().includes(s) ||
      w.client_company?.toLowerCase().includes(s)
    );
  });

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.28em] text-slate-500">Work orders</div>
        <h1 className="font-display text-3xl md:text-4xl tracking-tighter font-medium mt-2">Manage all work orders</h1>
      </div>

      <div className="flex flex-wrap gap-3 items-center">
        <input
          data-testid="admin-wo-search"
          type="text"
          placeholder="Search property, client, service…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="px-3 py-2 bg-white border border-slate-300 focus:border-[#1E40AF] outline-none text-sm rounded-sm w-72"
        />
        <select
          data-testid="admin-wo-status-filter"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="px-3 py-2 bg-white border border-slate-300 outline-none text-sm rounded-sm"
        >
          <option value="all">All statuses</option>
          <option value="pending">Pending</option>
          <option value="assigned">Assigned</option>
          <option value="in_progress">In progress</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
        <div className="text-xs text-slate-500 ml-auto">{filtered.length} results</div>
      </div>

      <div className="bg-white border border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-[0.2em] text-slate-500">
            <tr>
              <th className="text-left px-5 py-3 font-semibold">ID</th>
              <th className="text-left px-5 py-3 font-semibold">Client</th>
              <th className="text-left px-5 py-3 font-semibold">Property</th>
              <th className="text-left px-5 py-3 font-semibold">Service</th>
              <th className="text-left px-5 py-3 font-semibold">Priority</th>
              <th className="text-left px-5 py-3 font-semibold">Status</th>
              <th className="text-right px-5 py-3 font-semibold">Created</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan="7" className="px-5 py-10 text-center text-slate-400">No work orders match.</td></tr>
            )}
            {filtered.map((wo) => (
              <tr key={wo.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-5 py-3 font-mono-alt text-xs text-slate-500">{wo.id.slice(-6).toUpperCase()}</td>
                <td className="px-5 py-3 text-slate-700">
                  <div className="font-medium">{wo.client_company || wo.client_name}</div>
                  <div className="text-xs text-slate-500">{wo.client_email}</div>
                </td>
                <td className="px-5 py-3">
                  <Link to={`/admin/work-orders/${wo.id}`} data-testid={`admin-wo-${wo.id}`} className="text-slate-900 hover:text-[#1E40AF] font-medium">
                    {wo.property_address}
                  </Link>
                </td>
                <td className="px-5 py-3 text-slate-600">{wo.service_type}</td>
                <td className="px-5 py-3 text-slate-600 capitalize">{wo.priority}</td>
                <td className="px-5 py-3"><StatusBadge status={wo.status} /></td>
                <td className="px-5 py-3 text-right text-xs text-slate-500 tabular-nums">
                  {new Date(wo.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
